var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.cols}},[_vm._m(0)])])]):(_vm.isEmpty)?_c('tbody',[_c('tr',[_c('td',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('NotFoundOrder'))+" ")])])])]):_c('tbody',[_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('span',{staticClass:"loader"})])
}]

export { render, staticRenderFns }